import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import Strings from '../../../Strings';
import { isShipper, isSuperUser } from '../../../utils/userRoles';
import TabView, { Tab } from '../../../components/TabView';
import HubDevices from './HubDevices';
import DeviceStatusHistory from './DeviceStatusHistory';
import ShipperCapsDetails, { getCapHeader } from '../../ShipperCapsDetails';
import { actions } from '../../ShipperCapsDetails/redux/actions';
import { actions as provisioningActions } from '../Provisioning/redux/actions';
import { openModalAction } from '../../../actions/modal';
import { ADD_NICK_NAME } from '../../../actions/action-types';
import { DeviceTypes } from '../../../utils/deviceTypes';
import { EDIT_DEVICE_SAMPLE_STATUS_MODAL_NAME } from '../../../modals/EditDeviceSampleStatusModal';

export const CAP_EVENTS_TAB = Strings.events;
export const CAP_STATUS_HISTORY_TAB = Strings.history;
export const HUB_DEVICES_TAB = Strings.devices;

function CapDetails(props) {
  const capId = encodeURIComponent(props.match.params.id);
  const type = props.match.params.type;
  const { activeTab } = props;
  const [capInfo, setCapInfo] = React.useState({});

  const pageRequest = {
    offset: 0,
    search: '',
    filterBy: '',
    limit: 1,
  };

  const load = () => {
    props.getCapsDetails(capId, pageRequest).then(resp => {
      if (resp.response) {
        setCapInfo(resp.response);
      }
    });
  };

  const onEditSampleStatus = () => {
    props.openSampleStatusModal({
      deviceId: capInfo?.cap_id || capId,
      isSample: !!capInfo?.is_sample,
      onSuccess: load,
    });
  };

  React.useEffect(() => {
    load();
  }, [capId, activeTab]);

  const rootPath = `/devices/${type}/${capId}`;
  const tabs = [];
  if (type === DeviceTypes.Datahub.id) {
    tabs.push(
      <Tab name={HUB_DEVICES_TAB} path={`${rootPath}/devices`} key={HUB_DEVICES_TAB}>
        <HubDevices {...props} noHeader />
      </Tab>,
    );
  }
  tabs.push(
    <Tab name={CAP_EVENTS_TAB} path={`${rootPath}/events`} key={CAP_EVENTS_TAB}>
      <ShipperCapsDetails {...props} noHeader />
    </Tab>,
  );

  if (isSuperUser() || isShipper()) {
    tabs.push(
      <Tab name={CAP_STATUS_HISTORY_TAB} path={`${rootPath}/history`} key={CAP_STATUS_HISTORY_TAB}>
        <DeviceStatusHistory {...props} />
      </Tab>,
    );
  }

  return (
    <>
      {getCapHeader(
        capInfo,
        type,
        () => props.editCapName(load, capInfo.cap_name, capId),
        true,
        'white',
        onEditSampleStatus,
        props.timezone,
      )}
      <TabView activeTab={activeTab} routeMode>
        {tabs}
      </TabView>
    </>
  );
}

CapDetails.propTypes = {
  history: PropTypes.shape({
    location: PropTypes.shape({ state: PropTypes.shape({ params: PropTypes.shape({ offset: PropTypes.any }) }) }),
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({ id: PropTypes.any }),
    url: PropTypes.shape({ replace: PropTypes.func }),
  }),
  capInfo: PropTypes.shape({
    signal_strength: PropTypes.string,
    battery: PropTypes.number,
  }),
  activeTab: PropTypes.string,
  getCapsDetails: PropTypes.func,
  clearCapsDetails: PropTypes.func,
  editCapName: PropTypes.func,
  openSampleStatusModal: PropTypes.func,
  timezone: PropTypes.string,
};

const mapStateToProps = state => ({
  timezone: state.auth?.profile?.preferences?.timezone,
});

const mapDispatchToProps = dispatch => ({
  getCapsDetails: (id, pageRequest) => dispatch(provisioningActions.getCapsDetails(id, pageRequest)),
  editCapName: (nextAction, capName, id) =>
    dispatch(
      openModalAction('add-nick-name', {
        action: actions.addNickName,
        actionType: ADD_NICK_NAME,
        id,
        onSuccess: nextAction,
        capName,
        allowEmpty: true,
      }),
    ),
  openSampleStatusModal: data => dispatch(openModalAction(EDIT_DEVICE_SAMPLE_STATUS_MODAL_NAME, data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CapDetails);
